import { formatDate, mString } from 'lib/helpers/utility';

const handleEstLabel = ({ amount, isEstimated, label }) => {
  const finalLabel = label || mString(amount || 0);

  if (isEstimated && amount > 0) {
    return `estimated ${finalLabel}`;
  }

  return finalLabel;
};

export const PARENT_COLUMN_DEFS = (practiceTimezone, isAEOB, claims) => [
  {
    field: 'details',
    cellClass: 'no-border',
    cellRenderer: 'agGroupCellRenderer',
    minWidth: 100,
    resizable: false,
    showRowGroup: true,
    suppressMenu: true,
    flex: 1
  },
  {
    field: 'dateofservice',
    headerName: 'DOS',
    valueFormatter: ({ value }) => formatDate(value, practiceTimezone, true),
    maxWidth: 130,
    cellClass: 'no-border',
    flex: 1
  },
  { field: 'type', cellClass: 'no-border', hide: !isAEOB, flex: 1 },
  {
    field: 'qty',
    maxWidth: 80,
    minWidth: 70,
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'charge',
    valueFormatter: ({ value }) => mString(value || 0),
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'ins_payment',
    headerName: 'Ins Pay',
    valueGetter: (params) => {
      const amount = params?.data?.ins_payment;
      const isEstimated = params?.data?.isEstimated;

      return handleEstLabel({ amount, isEstimated });
    },
    hide: !claims || !isAEOB,
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'ins_adjustment',
    headerName: 'Ins Adj',
    valueGetter: (params) => {
      const amount = params?.data?.ins_adjustment;
      const isEstimated = params?.data?.isEstimated;
      const finalInsAdj = amount != null ? mString(amount || 0) : '-';

      return handleEstLabel({ amount, isEstimated, label: finalInsAdj });
    },
    hide: !claims || !isAEOB,
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'other_adj',
    headerName: 'Other Adj',
    valueFormatter: ({ value }) => mString(value || 0),
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'ins_balance',
    headerName: 'Ins Balance',
    valueFormatter: ({ value }) => mString(value || 0),
    sortable: false,
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'ptBalance',
    valueFormatter: ({ value }) => mString(value || 0),
    maxWidth: 120,
    cellClass: 'no-border',
    flex: 1
  }
];

export const CHILDREN_COLUMN_DEFS = (practiceTimezone, isAEOB, claims) => [
  {
    field: 'details',
    cellClass: 'no-border',
    cellRenderer: 'agGroupCellRenderer',
    minWidth: 100,
    resizable: false,
    showRowGroup: true,
    suppressMenu: true
  },
  {
    field: 'dateofservice',
    headerName: 'DOS',
    valueFormatter: ({ value }) => formatDate(value, practiceTimezone, true),
    maxWidth: 130,
    cellClass: 'no-border',
    flex: 1
  },
  { field: 'type', cellClass: 'no-border', hide: !isAEOB, flex: 1 },
  {
    field: 'qty',
    maxWidth: 80,
    minWidth: 70,
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'charge',
    valueFormatter: ({ value }) => mString(value || 0),
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'ins_payment',
    headerName: 'Ins Pay',
    valueGetter: (params) => {
      const amount = params?.data?.ins_payment;
      const isEstimated = params?.data?.isEstimated;

      return handleEstLabel({ amount, isEstimated });
    },
    hide: !claims || !isAEOB,
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'ins_adjustment',
    headerName: 'Ins Adj',
    valueGetter: (params) => {
      const amount = params?.data?.ins_adjustment;
      const isEstimated = params?.data?.isEstimated;

      return handleEstLabel({ amount, isEstimated });
    },
    hide: !claims || !isAEOB,
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'other_adj',
    headerName: 'Other Adj',
    valueFormatter: ({ value }) => mString(value || 0),
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'ins_balance',
    headerName: 'Ins Balance',
    valueFormatter: ({ value }) => mString(value || 0),
    maxWidth: 120,
    cellClass: 'no-border',
    flex: 1
  },
  {
    field: 'ptBalance',
    valueFormatter: ({ value }) => mString(value || 0),
    maxWidth: 120,
    cellClass: 'no-border',
    flex: 1
  }
];
